<template>
  <div class="custom-language-input-container">
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <label v-if="label">{{ label }} {{ validation.split('|').includes('required') ? '*' : '' }}</label>
      <div class="custom-language-input-container-main">
        <select
          :ref="name"
          v-bind="field"
          class="bordered-bottom"
          @change="onChange"
        >
          <option
            v-if="placeholder"
            disabled
            :value="undefined"
          >
            {{ placeholder }}
          </option>
          <option
            v-for="(option, index) in selectOptions"
            :key="index"
            :value="index"
          >
            {{ option }}
          </option>
        </select>
      </div>
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/*
 * Props:
 * placeholder: optional, only if u want a disabled/selected option to be displayed as title
 * name: input name (string)
 * value: the value of the option that need to be displayed first (Number) --!! if you want a placeholder to be set this need to be undefined !!--
 * dataOptions:
 *      [
 *      {
 *        value: value of the option([String, Number]),
 *        label: label displayed of the selected (string)
 *      }
 *      ]
 */

export default {
  name: 'CustomLanguageSelect',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: [String, Number],
    defaultValue: [String, Array],
    name: String
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onChange() {
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-language-input-container {
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    .custom-language-input-container-main {
      text-align: left;

      label {
        padding-left: 12px;
        color: #777;
        font-size: 0.75rem !important;
        font-weight: bold;
      }
    }

    .custom-language-input-content {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      white-space: nowrap;
      align-items: center;
      padding-left: 0.5rem;
      margin-top: 9px;

      input {
        border: none;
      }
    }

    select,
    input {
      height: 100%;
      border: none;
    }

    select {
      flex-grow: 1;
      appearance: none;
      text-indent: 4px;
      text-overflow: '';
      padding-right: 4px;
      background-image: url('@/assets/icons/arrow-select.png');
      background-position: center right;
      background-origin: content-box;
      background-repeat: no-repeat;
      background-size: contain;
      color: rgb(var(--secondary-color));
    }
  }
</style>
